import {noticeConstants, uriConstants} from '../../constants'
import {defaultService} from '../../services'
import {errorMessages} from '../../messages'
import {alertActions} from '../'

export const noticeActions = {
	load,
	select,
	detail,
}

/*********
 로딩
 **********/

function load(params) {
	return async dispatch => {
		dispatch(apiAction(noticeConstants.LOAD_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.GET_NOTICE + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(noticeConstants.LOAD_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(noticeConstants.LOAD_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/******
 상세화면
 *****/

function detail(seq, params) {
	return async dispatch => {
		dispatch(apiAction(noticeConstants.DETAILS_REQUEST))

		const queryString = require('query-string');
		let paramStr = queryString.stringify(params);
		paramStr.length > 0 && (paramStr = "?" + paramStr)

		defaultService.handleService({
			method: 'get',
			endPoint: uriConstants.API_URI + uriConstants.GET_NOTICE + '/' + seq + paramStr,
		})
			.then(
				response => {
					dispatch(apiAction(noticeConstants.DETAILS_SUCCESS, response))
				},
				error => {
					dispatch(apiAction(noticeConstants.DETAILS_FAILURE, error))
					dispatch(apiError(error))
				}
			)
	}
}

/*********
 셀렉트
 **********/

function select(params) {
	return async dispatch => {
		dispatch(request())
	}

	function request() {
		return {
			type: noticeConstants.SELECT_REQUEST,
			params
		}
	}
}

/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
	let resultObj = {type};
	response && (resultObj.response = response)
	return resultObj;
}

/**
 * API 통신 에러 문구 공통처리
 */
function apiError(error) {
	return alertActions.error({
		title: null,
		message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
	})
}
